import store from 'app/store/store';

const userAllowed = ['@oneclick.es'];

export function isOneclickUser(authUser) {
  return userAllowed.some((username) => authUser?.username?.includes(username));
}

export function isThirdPartyIntegrations(authUser) {
  const state = store.getState();
  const third_party_integrations = state?.['system-setting']?.settings?.third_party_integrations;
  const isAllowed = isOneclickUser(authUser);

  return !!third_party_integrations && !isAllowed;
}

export function roleExists(roleGuid) {
  const state = store.getState();
  const roles = state?.entities?.users?.roles || [];
  return roles.some((role) => role.guid === roleGuid);
}
